var map = {
	"./filters/abs.filter.js": 379,
	"./filters/capitalize.filter.js": 380,
	"./filters/unit.filter.js": 381
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 378;


//////////////////
// WEBPACK FOOTER
// ./src/app .*\.filter\.js$
// module id = 378
// module chunks = 0